import React from 'react'
import { InternationalCalculatorProvider } from './InternationalCalculatorContext'
import { CalculatorForm } from './CalculatorForm'

const INITIAL_SERVICE = 'PICKUP_PARCEL'

export const CalculatorInternational = ({ labels, serviceUrlCountries, serviceUrlPriceCalc }) => (
    <InternationalCalculatorProvider initialService={ INITIAL_SERVICE }>
        <CalculatorForm {...{
                serviceUrlCountries,
                serviceUrlPriceCalc,
                labels
            }} />
    </InternationalCalculatorProvider>

)
